module.exports = __webpack_public_path__ + "static/media/percentage.99435a67.svg";